import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect, useState } from 'react';
import useStyles from './HeroBanner.styles';
import { useMediaQuery } from 'react-responsive';
import { useTheme, Box } from '@mui/material';
import { colors } from '../../styles/jss/variables';
import { useBackgroundClass } from '../../styles/jss/utils';
import GenericImage from '../GenericImage/GenericImage';
import Content from '../Content/Content';
import clsx from 'clsx';
const HeroBanner = (props) => {
    var _a;
    const { classes } = useStyles();
    const theme = useTheme();
    const isMobileDevice = !useMediaQuery({ query: `(min-width: ${theme.breakpoints.values.sm}px)` });
    const [isMobile, setIsMobile] = useState(false);
    const { headingTag = 'H3', desktopBackgroundAndHeaderTextColors, mobileBackgroundAndHeaderTextColors, textContentPosition = 'TOP', } = props;
    const parseColor = (colorString, index) => {
        if (colorString) {
            return colorString.split('-')[index].trim();
        }
        else {
            return '';
            // Commenting below as we don't need default red and black combo for now
            // if (index === 0) {
            //   return 'RED'
            // } else {
            //   return 'BLACK'
            // }
        }
    };
    const bannerMinHeight = (_a = props.minHeight) !== null && _a !== void 0 ? _a : 'MEDIUM';
    let minHeightClass;
    switch (bannerMinHeight === null || bannerMinHeight === void 0 ? void 0 : bannerMinHeight.toUpperCase()) {
        case 'SMALL':
            minHeightClass = classes.minHeightSmall;
            break;
        case 'MEDIUM':
            minHeightClass = classes.minHeightMedium;
            break;
        case 'LARGE':
            minHeightClass = classes.minHeightLarge;
            break;
        default:
            minHeightClass = '';
    }
    const getContentMarginOverrideClass = () => {
        var _a, _b;
        let contentMarginClass = '';
        if (!props.contentPosition || props.contentPosition === 'LEFT') {
            contentMarginClass = (_a = classes.removeContentRightMargin) !== null && _a !== void 0 ? _a : '';
        }
        else if (props.contentPosition === 'RIGHT') {
            contentMarginClass = (_b = classes.removeContentLeftMargin) !== null && _b !== void 0 ? _b : '';
        }
        return contentMarginClass;
    };
    const getContentPositionClass = () => {
        if (props.contentPosition === 'RIGHT')
            return classes.homeBannerRightContainer;
        if (props.contentPosition === 'LEFT')
            return classes.homeBannerLeftContainer;
        return '';
    };
    useEffect(() => {
        setIsMobile(isMobileDevice);
    }, [isMobileDevice]);
    const backgroundColorHeroBanner = useMemo(() => parseColor(isMobile
        ? mobileBackgroundAndHeaderTextColors || props.backgroundColor
        : desktopBackgroundAndHeaderTextColors || props.backgroundColor, 0), [isMobile, mobileBackgroundAndHeaderTextColors, desktopBackgroundAndHeaderTextColors, props.backgroundColor]);
    const headingColorHeroBanner = useMemo(() => {
        const color = parseColor(isMobile ? mobileBackgroundAndHeaderTextColors !== null && mobileBackgroundAndHeaderTextColors !== void 0 ? mobileBackgroundAndHeaderTextColors : '' : desktopBackgroundAndHeaderTextColors !== null && desktopBackgroundAndHeaderTextColors !== void 0 ? desktopBackgroundAndHeaderTextColors : '', 1);
        return color.toUpperCase().replace(' ', '_');
    }, [isMobile, mobileBackgroundAndHeaderTextColors, desktopBackgroundAndHeaderTextColors]);
    const heading = (props === null || props === void 0 ? void 0 : props.heading) && typeof props.heading === 'string' && props.heading.trim()
        ? props.heading.split('/').map((line) => (_jsx("span", { className: clsx(classes.headingLine), style: { color: colors.genericContentHeading[headingColorHeroBanner] }, children: line.trim() }, line)))
        : props.heading;
    const textColor = useMemo(() => {
        switch (backgroundColorHeroBanner) {
            case 'PURPLE':
            case 'DARK GREY':
                return 'WHITE';
            default:
                return 'BLACK';
        }
    }, [backgroundColorHeroBanner]);
    const getTextColor = () => {
        switch (textColor) {
            case 'BLACK':
                return classes.black;
            case 'WHITE':
                return classes.white;
            default:
                return classes.black;
        }
    };
    const getTextContentPositionClass = () => {
        switch (textContentPosition.toUpperCase()) {
            case 'TOP':
                return classes.positionTop;
            case 'CENTER':
                return classes.positionCenter;
            case 'BOTTOM':
                return classes.positionBottom;
            default:
                return classes.positionTop;
        }
    };
    const { bgClass } = useBackgroundClass(backgroundColorHeroBanner);
    return (_jsxs(Box, { className: clsx(classes.fontSohne, minHeightClass, bgClass, classes.container), children: [!isMobile && (_jsx(GenericImage, { fullWidthImage: true, image: props.image, classNames: [minHeightClass, classes.image, classes.minHeightSmall], renderSquareImage: true, minHeight: props.minHeight })), _jsx(Content, { heading: heading, headingClasses: [classes.heading], contentInnerClasses: [classes.contentInner, getContentMarginOverrideClass(), getTextContentPositionClass()], headingTag: headingTag, messageClasses: [getTextColor(), classes.message], message: props.message, defaultTextContentPosition: "" // This is to override the default value of textContentPosition in Content component
                , links: props.links, linkStyle: 'BUTTON', linkContainerClasses: [classes.linkContainer], containerClasses: [classes.content, minHeightClass, getContentPositionClass()] })] }));
};
export default HeroBanner;
